import { isValid, parse } from 'date-fns';
import { route, string } from 'react-router-typesafe-routes';

import { DateFormat } from '@utils/DateHelper';

const LOCAL_DATE_REG_EXP = /^\d{2}\.\d{2}\.\d{4}$/;

function localDate(value: string): string {
    if (!LOCAL_DATE_REG_EXP.test(value) || !isValid(parse(value, DateFormat.DateWithDotSeparator, new Date()))) {
        throw new Error(`"${value}" is not a date in the ${DateFormat.DateWithDotSeparator} format`);
    }

    return value;
}

export const PLAN_LIST_ROUTE = route({ path: 'plan' });

export const PLAN_ROUTE = route({
    path: 'plan/:planId',
    searchParams: {
        versionStartDate: string(localDate),
        payerId: string(),
        currentPage: string(),
    },
});
